import { render, staticRenderFns } from "./point-edit.vue?vue&type=template&id=bd5dd7ac"
import script from "./point-edit.vue?vue&type=script&lang=js"
export * from "./point-edit.vue?vue&type=script&lang=js"
import style0 from "./point-edit.vue?vue&type=style&index=0&id=bd5dd7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports